import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { setTIN, setVAT } from "../../reducer/registrationReducer";
import { setTaxDetailsModal } from "../../reducer/modalReducer";

function TaxDetailModal() {
  const dispatch = useDispatch();
  const { TIN, VAT } = useSelector((state: RootState) => state.registration);
  const { taxDetailModal } = useSelector((state: RootState) => state.modal);

  const [editedVAT, setEditedVAT] = useState<string>(VAT);
  const [editedTIN, setEditedTIN] = useState<string>(TIN);

  const handleSaveChanges = () => {
    dispatch(setVAT(editedVAT));
    dispatch(setTIN(editedTIN));
    dispatch(setTaxDetailsModal(false));
  };

  const handleCancelEdit = () => {
    dispatch(setTaxDetailsModal(false));
  };

  const handleBackdropClick = (event: any) => {
    if (event.target === event.currentTarget) {
      handleCancelEdit();
    }
  };

  return (
    <div
      className={`fixed z-50 top-0 left-0 w-full h-full items-center justify-center bg-gray-500 bg-opacity-75 ${
        taxDetailModal ? "flex" : "hidden"
      } `}
      onClick={handleBackdropClick}
    >
      <div className={Classname.modalContent}>
        <div className={Classname.title}>Tax details</div>
        <div>VAT number</div>
        <input
          type="text"
          value={editedVAT}
          onChange={(e) => setEditedVAT(e.target.value)}
          className={Classname.input}
        />
        <div>Tax identification number</div>
        <input
          type="text"
          value={editedTIN}
          onChange={(e) => setEditedTIN(e.target.value)}
          className={Classname.input}
        />
        <div className={Classname.justifyEnd}>
          <button onClick={handleCancelEdit} className={Classname.button}>
            Cancel
          </button>
          <button onClick={handleSaveChanges} className={Classname.saveButton}>
            Save changes
          </button>
        </div>
      </div>
    </div>
  );
}

export default TaxDetailModal;

const Classname = {
  modalContent:
    "bg-white p-6 mx-2 w-full max-w-[500px] rounded shadow-md max-h-[90vh] overflow-scroll",
  title: "font-bold mb-2",
  input: "w-full border border-gray-300 p-2 mt-2 rounded-md h-10 mb-4",
  button: "px-4 py-2 rounded-lg border-blue-500 border",
  saveButton: "ml-2 bg-blue-500 text-white px-4 py-2 rounded-lg",
  justifyEnd: "mt-4 flex justify-end",
};
